var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { cursor: "pointer", width: "fit-content" } },
    [
      this.mood === "normal"
        ? _c(
            "div",
            {
              on: {
                click: function($event) {
                  return _vm.getFile()
                }
              }
            },
            [_vm._v(" " + _vm._s(_vm.label || _vm.name) + " ")]
          )
        : _vm._e(),
      this.mood === "compact"
        ? _c(
            "span",
            {
              staticStyle: { cursor: "pointer", width: "fit-content" },
              on: {
                click: function($event) {
                  return _vm.getFile()
                }
              }
            },
            [_c("feather-icon", { attrs: { icon: "FileTextIcon" } })],
            1
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }